const paths = {
  // todo move other paths here
  home: '/home',
  transparencyData: '/transparency-data',
  reporting: '/best-execution-reporting',
  reportingDownload: '/best-execution-reporting/download',
  dataSelect: '/dataSelect',
  documentationLoad: '/documentation'
};

export default paths;


// WEBPACK FOOTER //
// ./src/common/constants/paths.js